import React, { ReactNode } from "react";
import { Placeholder, Spinner } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";

import "./DstButton.scss";

const DstButton = ({
  backgroundColor,
  btnClass = "s-bold",
  btnImage,
  btnSize = "auto",
  children,
  clickFunction,
  color,
  disabled,
  link,
  loading,
  loadingColor,
  mock,
  target = "_self",
  title,
  type = "button",
  value = "Click here",
  variant = "primary",
}: {
  backgroundColor?: string;
  btnClass?: string;
  btnImage?: JSX.Element;
  btnSize?: string;
  children?: ReactNode;
  clickFunction?: Function;
  color?: string;
  disabled?: boolean;
  link?: string;
  loading?: boolean;
  loadingColor?: string;
  mock?: boolean;
  target?: string;
  title?: string;
  type?: "submit" | "button" | "reset" | undefined;
  value?: string | JSX.Element;
  variant?: string;
}) => {
  if (mock) {
    return (
      <Placeholder animation="glow">
        <Placeholder.Button
          className={`btn font-m ${btnClass}`}
          style={{
            width: btnSize,
          }}
          aria-hidden="true"
        />
      </Placeholder>
    );
  }
  const buttonClass = `btn btn-${variant} ${btnClass}`;

  return link ? (
    link.startsWith("http") ? (
      <a
        className={buttonClass}
        style={{
          backgroundColor: backgroundColor,
          color: color,
          width: btnSize,
        }}
        href={link}
        target={target}
        title={title}
      >
        {btnImage}
        {value}
      </a>
    ) : (
      <Link
        className={buttonClass}
        style={{
          backgroundColor: backgroundColor,
          color: color,
          width: btnSize,
        }}
        target={target}
        to={link}
        title={title}
      >
        {btnImage}
        {value}
      </Link>
    )
  ) : (
    <Button
      variant={variant}
      className={btnClass}
      style={{
        backgroundColor: backgroundColor,
        color: color,
        width: btnSize,
      }}
      type={type}
      title={title}
      onClick={() => (clickFunction ? clickFunction() : null)}
      disabled={disabled}
    >
      {loading ? (
        <Spinner
          animation="border"
          className="d-block mx-auto"
          color={loadingColor || "var(--color-white)"}
          size={btnSize === "lg" ? undefined : "sm"}
        />
      ) : (
        <React.Fragment>
          {btnImage}
          {value}
          {children}
        </React.Fragment>
      )}
    </Button>
  );
};
export default DstButton;
